<!-- <div fxLayoutGap="20px" class="card card-class"> -->

<form [formGroup]="questionForm">
  <h1 mat-dialog-title>{{data.title}}</h1>
    <div>
        <div class="content-material">
            <div mat-dialog-content>
                <mat-form-field appearance="fill">
                    <mat-label>Select Subject</mat-label>
                    <mat-select formControlName="Subject_SysRef">
                        <mat-option *ngFor="let subject of (dataSubjectList$ | async)" [value]="subject.sysRef">
                            {{subject.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" [style.width.%]="100">
                  <mat-label>Question Text</mat-label>
                  <input matInput formControlName="questiontext" placeholder="Enter the question text">
                </mat-form-field>
            </div>
        </div>

        <!--Reapeatables-->
        <div style="display: flex; background-color: #DEDEDE;">
          <div class="answersDialog" style="border:solid">
            <span style="padding:5px"> Diffculties</span>
            <div formArrayName="modifiers">
              <div style="display:flex">
                <span style="padding:10px">(Add a minimum of one item)</span>
                <div style="flex-grow: 5; text-align: right;padding:3px">
                  <button type="button" mat-button (click)="addModifier()">Add</button>
                </div>
              </div>
              <div style="display:flex" *ngFor="let m of Modifiers().controls; let i=index" [formGroupName]="i">
                <mat-form-field appearance="fill">
                  <mat-label>Select Diffculty</mat-label>
                  <mat-select formControlName="sysRef">
                    <mat-option *ngFor="let modifier of (dataLevelList$ | async)" [value]="modifier.sysRef">
                      {{modifier.description}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="answersDialog" style="border:solid">
            <span style="padding:5px">Answers</span>
            <div formArrayName="answers">
              <div style="display:flex">
                <span style="padding:10px">(Add a minimum of one correct and wrong answer)</span>
                <div style="flex-grow: 5; text-align: right; padding: 3px">
                  <button type="button" mat-button (click)="addAnswers()">Add</button>
                </div>
              </div>
              <div style="display:flex" *ngFor="let answer of answers().controls; let i=index" [formGroupName]="i">
                <div style="width:100%;display:flex;justify-content:space-evenly;">
                  <div style="display:flex;">
                    <input style="position:relative; vertical-align:central" type="checkbox" formControlName="isCorrect" (change)="changeValue()" />
                  </div>
                  <div>
                    <mat-form-field>
                      <mat-label>Answer Text</mat-label>
                      <input matInput formControlName="answerText" placeholder="Enter the answer text" class="form-control">
                    </mat-form-field>
                  </div>
                  <div>
                    <mat-form-field style="flex-grow:3">
                      <mat-label>Marks</mat-label>
                      <input matInput type="number" formControlName="scoreValue" class="form-control">
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <button type="button" mat-button (click)="onSubmit(true)">Save and Add New</button>
        <button type="button" mat-button cdkFocusInitial (click)="onSubmit(false)">Save and Close</button>
    </div>
</form>
